var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBimifyLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1",
    clipPath: "url(#clip0_0_48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7998 0H0V43H29.7998V36.7656H6.75062V24.3189H29.7998V18.0764H6.75062V6.23442H29.7998V18.0764H36V6.23342H29.7998V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9993 24.3189H29.7991V36.7656H35.9993V24.3189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBimifyLogomark);
export default __webpack_public_path__ + "static/media/bimify-logomark.6fd74155502b229afcc5c84229b85903.svg";
export { ForwardRef as ReactComponent };